import styled from 'styled-components';

type Props = {
  color?: string,
  onClick: () => void,
} & typeof defaultProps;

const defaultProps = {
  color: '#CBCBCA',
};
const SVGWrapper = styled.svg`
 cursor: pointer;
 &:hover {
   circle {
     fill: #565656;
   }
 }
 `;
const SliderCircledForwardIcon = function SliderCircledForwardIcon(props: Props) {
  const { color, onClick } = props;
  return (
    <SVGWrapper xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="slider-circled-forward-icon" onClick={onClick}>
      <circle cx="12" cy="12" r="12" transform="rotate(-180 12 12)" fill={color} />
      <path d="M15.6077 11.884C15.5999 12.1228 15.5064 12.3504 15.3449 12.5235L10.7579 17.3954C10.3918 17.7839 9.78612 17.7961 9.40513 17.4228C9.02414 17.0495 9.01211 16.4319 9.37826 16.0434L13.3262 11.8475L9.37826 7.65155C9.01211 7.26308 9.02414 6.64551 9.40513 6.27217C9.78612 5.89883 10.3918 5.9111 10.7579 6.29957L15.3449 11.1715C15.5236 11.3628 15.6185 11.62 15.6077 11.884Z" fill="white" />
    </SVGWrapper>
  );
};
SliderCircledForwardIcon.defaultProps = defaultProps;
export default SliderCircledForwardIcon;
